import React, { createContext, useState } from 'react'
import ajax from 'ajax'
import PhoneComUser from 'phone-com-user'
import eventTranslator from '../utils/event-translator'

const ENROLLMENT_EVENTS_PAGE_SIZE = 20

/**
 *
 */
interface IEnrollmentEvent {
    eventName: string
    eventDescription: string
    description: string
    createdAt: string
}

/**
 *
 */
export type EntityType = 'brand' | 'campaign'

/**
 *
 */
interface IEnrollmentEventCollection {
    id: string
    type: EntityType | 'invalid'
    events: IEnrollmentEvent[]
    hasMore: boolean
    // list: () => Promise<void>
    // onUpdate: (id: string, events: IEnrollmentEvent) => Promise<void>
}

const EnrollmentEventsContext = createContext({
    list: async (entityType: 'brand' | 'campaign', id: string) => Promise.resolve({
        id: id,
        type: entityType,
        events: [],
        hasMore: false
    } as IEnrollmentEventCollection),
    events: new Map<string, IEnrollmentEventCollection>(),
    removeEventsForId: (id: string) => console.log('EnrollmentEventsContext not initiated')

})

/**
 *
 */
const EnrollmentEventsContextProvider = (props: { children }) => {
    const [enrollmentEvents, setEnrollmentEvents] = useState<Map<string, IEnrollmentEventCollection>>(new Map())
    const fetchEvents = async (requestUrl, request, entityType: EntityType): Promise<IEnrollmentEvent[]> => {
        return await ajax.post(requestUrl, request).then((response) => {
            const events = [] as IEnrollmentEvent[]
            response.data?.events?.forEach((event) => {
                events.push({
                    eventName: event.event_name,
                    eventDescription: event.event_description,
                    description: event.description,
                    createdAt: event.created_at
                })
            })

            // events.unshift({ // for brands
            //     eventName: 'BRAND_IDENTITY_VET_UP_DATE',
            //     eventDescription: 'TEST',
            //     description: 'Testing test',
            //     createdAt: 1782722019
            // })

            // events.unshift({ // for campaigns
            //     "eventName": "CAMPAIGN_SHARE_DELETE",
            //     "eventDescription": "TEST",
            //     "description": "DCA declined sharing request for campaign C5ID7ST. Rejection category: PRIVACY_POLICY, CALL_TO_ACTION. Explanation: Rejection code 7103: Invalid privacy policy - The privacy policy does not mention that mobile opt-in willl not be shared, and appears to allow for the sharing of data with other companies. Rejection Code 2101: Invalid call to Action - no opt-in URL or attachment was found in th campaign submission.",
            //     // "description": "DCA2 declined sharing request for campaign CDNUYHU. Rejection Category: BRAND_INCONSISTENCIES. Explanation: Unable to verify, need working website or online presence provided for brand validation. (804)".
            //     "createdAt": 1782722019
            // })

            return eventTranslator(entityType, events)
        })
    }
    const list = async (entityType: EntityType, id: string): Promise<IEnrollmentEventCollection> => {
        let eventCollection: IEnrollmentEventCollection = {
            id,
            type: entityType,
            events: [],
            hasMore: true
        }
        if (enrollmentEvents.has(id)) {
            eventCollection = { ...(enrollmentEvents.get(id) as IEnrollmentEventCollection) }
        }

        if (!eventCollection.hasMore) {
            return eventCollection
        }

        if (eventCollection.type === 'brand') {
            const request = {
                // eslint-disable-next-line @typescript-eslint/naming-convention, camelcase
                csp_brand_id: id,
                limit: ENROLLMENT_EVENTS_PAGE_SIZE,
                offset: eventCollection.events.length
            }
            const requestUrl = PhoneComUser.getv5ApiRoot() + '/messages/10dlc/list-brand-events'
            const events = await fetchEvents(requestUrl, request, entityType)
            eventCollection.events = eventCollection.events.concat(events)
            eventCollection.hasMore = events.length === request.limit
        } else if (eventCollection.type === 'campaign') {
            const request = {
                // eslint-disable-next-line @typescript-eslint/naming-convention, camelcase
                csp_campaign_id: id,
                limit: ENROLLMENT_EVENTS_PAGE_SIZE,
                offset: eventCollection.events.length,
                sort: 'desc'
            }
            const requestUrl = PhoneComUser.getv5ApiRoot() + '/messages/10dlc/list-campaign-events'
            const events = await fetchEvents(requestUrl, request, entityType)
            eventCollection.events = eventCollection.events.concat(events)
            eventCollection.hasMore = events.length === request.limit
        }

        setEnrollmentEvents((currentEvents) => {
            const nextEvents = new Map(currentEvents)
            nextEvents.set(id, eventCollection)

            return nextEvents
        })

        return eventCollection
    }

    const removeEventsForId = (id: string) => {
        try {
            enrollmentEvents.delete(id)
            return true
        } catch {
            return false
        }
    }

    return (
        <EnrollmentEventsContext.Provider value={{
            list,
            events: enrollmentEvents,
            removeEventsForId
        }}>
            {props.children}
        </EnrollmentEventsContext.Provider>
    )
}

/**
 *
 */
export { IEnrollmentEvent, IEnrollmentEventCollection, EnrollmentEventsContext, EnrollmentEventsContextProvider }
